import { useMutation, useQueryClient } from "react-query";
import { QK } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";

interface RefreshSiteResult {
  refreshed: boolean;
  project_id: string;
  bma_site_id?: string;
  affected_fields?: string[];
  reason?: string;
}

// Re-pulls the linked Production site's data (figures, survey, cost sheet)
// onto the project. Triggered by "Refresh admin data" and once at project
// creation. ``force`` bypasses the BE's sync throttle so a manual click
// always re-pulls; only a real refresh invalidates the queries.
export const useRefreshSiteContributions = () => {
  const http = useAgentsHttp();
  const qc = useQueryClient();

  return useMutation<RefreshSiteResult, Error, string>(
    (projectId) =>
      http<RefreshSiteResult>("/projects/refresh_site", {
        project_id: projectId,
        force: true,
      }),
    {
      onSuccess: (result) => {
        if (!result.refreshed) return;
        qc.invalidateQueries({ queryKey: [QK.projectGet] });
        qc.invalidateQueries({ queryKey: [QK.projectsList] });
        qc.invalidateQueries({ queryKey: [QK.uploadsList] });
        // The site's tenant and landlord decide which client-scoped channels reach
        // the project, and a new project's Settings is already open when they land.
        qc.invalidateQueries({ queryKey: [QK.projectSlack] });
      },
    },
  );
};
